(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["m-custom-video-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('deferred-video-slider')) {
    customElements.define('deferred-video-slider', class extends HTMLElement {
      connectedCallback() {
        if (this.videoSliderReady) return;
        this.videoSliderReady = true;
        const videos = this.querySelectorAll('video[data-video-poster]');
        if ('IntersectionObserver' in window) {
          this.posterObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              this.loadPoster(entry.target);
              this.posterObserver.unobserve(entry.target);
            });
          }, { rootMargin: '400px 0px' });
          videos.forEach((video) => this.posterObserver.observe(video));
        } else {
          videos.forEach((video) => this.loadPoster(video));
        }
        this.track = this.querySelector('[data-video-track]');
        this.addEventListener('click', (event) => {
          const playButton = event.target.closest('[data-video-play]');
          if (playButton) {
            this.playVideo(playButton);
            return;
          }

          if (event.target.closest('[data-video-previous]')) {
            this.scrollTrack(-1);
          } else if (event.target.closest('[data-video-next]')) {
            this.scrollTrack(1);
          }
        });
      }

      loadPoster(video) {
        if (!video.dataset.videoPoster) return;
        video.poster = video.dataset.videoPoster;
        delete video.dataset.videoPoster;
      }

      playVideo(button) {
        const item = button.closest('.deferred-video-slider__item');
        const video = item.querySelector('video');
        this.loadPoster(video);
        this.querySelectorAll('video').forEach((otherVideo) => {
          if (otherVideo !== video) otherVideo.pause();
        });

        if (!video.src) {
          video.src = video.dataset.videoSrc;
          video.controls = true;
          video.load();
        }

        const playback = video.play();
        button.hidden = true;
        video.focus({ preventScroll: true });
        if (playback?.catch) playback.catch(() => {
          button.hidden = false;
          if (document.activeElement === video) button.focus({ preventScroll: true });
        });
      }

      scrollTrack(direction) {
        this.track.scrollBy({ left: this.track.clientWidth * 0.85 * direction, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
